import MainLayout from "layout/MainLayout";
import { Navigate } from "react-router-dom";

export const NoSubscriptionRequired = () => {
    const loggedIn = localStorage.getItem('token') !== null && localStorage.getItem('user') !== null;
    if (!loggedIn) {
      // user is not authenticated
      return <Navigate to="/login" />;
    }
    return <MainLayout />;
  };